import {CardMedia as MUICardMedia} from '@mui/material'

export const CardMedia = MUICardMedia
